module.exports = __webpack_public_path__ + "static/media/bouteilleMDG.5dfe1546.svg";